/* eslint-disable prettier/prettier */
import authApi from "../../api/authApi"

export const loginUser = async({ commit }, user)=>{
    const { username, password }= user
    try {
        const { data } = await authApi.post("/login",{username, password})
        const { token, user, roles}=data

        commit("loginUser",{token, user, roles })
        return{ok:true}
    } catch (error) {
        console.log("error", error);
        return {message:error}
    }
}

export const checkAuthentication = async({ commit })=>{
 const idToken = localStorage.getItem("token")
  if(!idToken ){
     commit("logout")
     return{ok:false, message:"no token provided"}
 }
 try {
     const headers = {'x-access-token': idToken}
     const {data} = await authApi.get("/is-verify", {headers: headers}) 
     const { token, user, roles}=data
     commit("loginUser",{token, user, roles })
     return{ok:true}
 } catch (error) {
     commit("logout")
     return{ok:false, message:error}
 }
}